import { SEO } from '../components/SEO';

export const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <SEO
        title="Privacy Policy | Your Casinos"
        description="Privacy policy for Your Casinos. Learn how we collect, use, and protect your personal information."
        canonical="/policies/privacy"
      />

      <div className="min-h-screen bg-black py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Privacy Policy
          </h1>
          <div className="glass-card p-8 space-y-6 text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Information We Collect</h2>
              <p>
                We collect information you provide directly, such as when you subscribe to our newsletter, 
                contact us, or interact with our website. This may include your name, email address, and 
                any messages you send us.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide and improve our services</li>
                <li>Send you updates and newsletters (with your consent)</li>
                <li>Respond to your inquiries</li>
                <li>Analyze website usage and trends</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Cookies</h2>
              <p>
                We use cookies to enhance your experience, analyze site traffic, and personalize content. 
                You can control cookies through your browser settings. For more details, see our{' '}
                <a href="/policies/cookies" className="text-primary-green hover:underline">Cookie Policy</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Third-Party Services</h2>
              <p>
                We may use third-party services for analytics and advertising. These services may collect 
                information about your visits to our website and other websites. We do not sell your 
                personal information to third parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Data Security</h2>
              <p>
                We implement appropriate security measures to protect your personal information. However, 
                no method of transmission over the internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Your Rights</h2>
              <p>
                Under UK GDPR, you have the right to access, correct, or delete your personal information. 
                You can also object to processing or request data portability. Contact us to exercise 
                these rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary-green mb-4">Contact Us</h2>
              <p>
                If you have questions about this privacy policy, please contact us through our website.
              </p>
            </section>

            <section>
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

